<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
       <el-form-item>
        <el-button type="primary" @click="openAdd">添加门店</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
     <template #handler="{ row }">
        <div>
          <el-button type="danger" size="small" @click="del(row)"
            >删除</el-button
          >
        </div>
      </template>
    </auto-table>

     <bindMec ref="add" @success="getList(1)"></bindMec>
  </div>
</template>

<script>
import bindMec from './bindMec.vue';
export default {
  components:{
      bindMec
  },
  data() {
    return {
      DataList: [],
      Option: [
        { name: "场地", value: "venue_name" },
        { name: "添加时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
      load: false,
      manager: JSON.parse( localStorage.getItem("managerInfo")),
    };
  },

  mounted() {
    this.id = this.$route.query.id;
  },

  methods: {
     
    init() {
      if (!this.load) {
        this.load = true;
        this.getList(1);
      }
    },
    openAdd() {
      let comm = { venue_id: this.id };
      this.$refs.add.open(comm);
    },
    del(row){
      this.$confirm("确认取消投资包绑定的场馆，取消后该场馆将不在参与分成").then(() => {
        this.$axios({
        url: "/user/investPackageVenue/cancel",
        params: {
          id: row.id,
        },
      }).then((res) => {
        this.getList(1);
      });
      })
      
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/investPackageVenue/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          package_id: this.id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>